var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0065 12.9673L16.0947 11.401C14.8474 10.3811 12.9174 10.4767 11.7794 11.615L11.702 11.6924C11.5108 11.8836 11.2013 11.8836 11.0146 11.6924L7.32299 7.99985C7.13636 7.81318 7.1318 7.51268 7.31388 7.32145C7.31844 7.31689 7.31844 7.31234 7.32299 7.31234L7.31388 7.32145C7.31844 7.31689 7.31844 7.31689 7.32299 7.31234C8.45188 6.16952 8.56113 4.22991 7.57335 2.97781L6.02112 1.01543C5.01968 -0.24577 3.28993 -0.345938 2.15193 0.792332L1.86516 1.07918C-0.146818 3.09619 -0.624776 6.7341 0.891035 9.15178C0.891035 9.15178 1.78322 11.2189 4.78753 14.2239C7.79184 17.2289 9.85844 18.1213 9.85844 18.1213C12.2983 19.5965 15.9126 19.1595 17.9291 17.1424L18.2022 16.8693C19.3357 15.7355 19.2492 13.9872 18.0065 12.9673ZM16.8275 15.4988L16.5544 15.772C15.1706 17.1561 12.5396 17.4748 10.8644 16.4595L10.7506 16.3912L10.6277 16.3365C10.4775 16.2728 10.0997 16.0679 9.5307 15.6855C8.52016 15.007 7.38216 14.0737 6.15768 12.8489C4.9332 11.6241 4.00004 10.4904 3.32179 9.4796C2.93943 8.91047 2.73459 8.53257 2.67086 8.38231L2.61168 8.24572L2.5343 8.11823C1.51466 6.49279 1.84695 3.84745 3.23986 2.44965L3.52663 2.16281C3.84072 1.84865 4.21853 1.86686 4.49621 2.21745L6.04843 4.17982C6.4308 4.66245 6.38073 5.50477 5.93918 5.94642C5.00148 6.89801 5.00603 8.42784 5.94829 9.37033L9.63995 13.0629C10.5868 14.0099 12.1253 14.0099 13.0767 13.0629L13.1541 12.9855C13.5865 12.5529 14.3922 12.5165 14.8656 12.9035L16.7775 14.4698C17.1325 14.7612 17.1507 15.1755 16.8275 15.4988Z",
    fill: "url(#paint0_linear_0_31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_31",
    x1: -6.11873,
    y1: 18.6624,
    x2: 13.0318,
    y2: -9.36926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon-8.cba15cbb96d1835300cc447f43951d63.svg";
export { ForwardRef as ReactComponent };